
import React from "react";
import ReactDOM from "react-dom";
import { ProjectParams } from "./projects";



interface HoverPortalParams {
    text: string;
    shouldAdd: boolean;
    el: React.ElementType;
    project: ProjectParams;
    blurAction: Function;
    deleteProject: Function;
    editProject: Function;
    hideReorder: boolean;
}

export const HoverPortal: React.FC<HoverPortalParams> =({ text, shouldAdd, el, project, blurAction, deleteProject, editProject, hideReorder})=> {
    if (!shouldAdd) return null

    return ReactDOM.createPortal(
        <div className={"thumbnail-overlay thumbnail-overlay-"+project.id}>

        <div onClick={hideReorder ? undefined : (e)=>editProject(e)} className="info-top">

            <span className="product_type">{project.projectType}</span>
            {
                !hideReorder &&
                <a onBlur={(e)=>blurAction(e, !project.showDeleteIcon)} tabIndex={0} onKeyDown={(e)=>{if(e.key === " " || e.key === "Enter")editProject(e);}} onClick={(e)=>editProject(e)} className="project_edit icon-icon_edit" aria-label={photoOrg.translations.projects['aria_label']['edit_project']}>&nbsp;{text}</a>
            }

        </div>
        
        {
           project.showDeleteIcon ? (
           <>
           {/** @ts-ignore */}
           <a project_id={project.id} onBlur={(e)=>blurAction(e, true)} tabIndex={0} onKeyDown={(e)=>{if(e.key === " " || e.key === "Enter")deleteProject();}} onClick = {(e)=>deleteProject(e)} className="deleteProject"  aria-label={photoOrg.translations.projects['aria_label']['delete_project']}
             name={"delete_project_"+project.id} style={{"display": "inline-block"}}>
            {/** @ts-ignore */}
            <span className="icon-icon_delete_outline" project_id={project.id} project_state={project.state}>{photoOrg.translations.projects["action_container"]["Delete"]}</span>
           </a></>) : null
        }
        
        
    </div>,  el as any)
  }

  export default HoverPortal